import { Store } from '@reduxjs/toolkit';
import store from '../store';
import { get } from 'lodash-es';
import { useRootMemoSelector } from 'use-redux-states';

export default abstract class Model<Prop = any> {
  store = store;
  static store: Store = store;
  private _contructed = false;
  private _props?: Prop;

  abstract storeAction;
  abstract storePath;

  constructor(props?: Prop) {
    if (props) {
      this._props = props;
      this._contructed = true;
    }
  }

  get props(): Prop {
    if (this._contructed) {
      return this._props as Prop;
    } else {
      return this.getPropsFromStore();
    }
  }

  set props(p: Prop) {
    this._props = p;
    this._contructed = true;
  }

  updateStore = (...p) => this.store.dispatch(this.storeAction(...p));

  getPropsFromStore = () => get(this.store.getState(), this.storePath);
}

export abstract class ReduxModel extends Model {
  useStore = (...p) => useRootMemoSelector(this.storePath, ...p);
}
